// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const TickCircleIcon: Icon = ({ size = 80, color, variant: _variant, className, style, ...rest }) => {
  const stroke = color || '#00A63E';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path
        d="M40 73.333C58.41 73.333 73.333 58.41 73.333 40C73.333 21.59 58.41 6.667 40 6.667C21.59 6.667 6.667 21.59 6.667 40C6.667 58.41 21.59 73.333 40 73.333Z"
        stroke={stroke}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.667 40L35.3 48.633L53.333 30.633"
        stroke={stroke}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { TickCircleIcon };
